import React from 'react'
export default function EventVenueReview({ previous, current }) {
  if (String(previous.club?.id || previous.club?.clubName || '') === String(current.club?.id || current.club?.clubName || '')) return null
  const name = value => value?.companyName || [value?.firstName, value?.lastName].filter(Boolean).join(' ')
  const rows = [
    ['Club', value => value.club?.clubName === null ? 'No Club' : value.club?.clubName],
    ['Location', value => [value.club?.location?.city, value.club?.location?.country].filter(Boolean).join(', ')],
    ['Timezone', value => value.timezone], ['Organizer', value => name(value.organizer)],
    ['Director', value => value.directorName], ['Email', value => value.organizer?.email], ['Phone', value => value.organizer?.phone],
  ]
  return <div className="alert alert-info event-venue-review"><h4>Review venue changes</h4><p>Existing entries and draws are preserved. Review the destination and contact details before saving.</p>
    <table className="table table-sm mb-0"><thead><tr><th scope="col">Field</th><th scope="col">Before</th><th scope="col">After</th></tr></thead><tbody>
      {rows.map(([label, read]) => <tr key={label}><th scope="row">{label}</th><td>{read(previous) || 'Not provided'}</td><td>{read(current) || 'Not provided'}</td></tr>)}
    </tbody></table></div>
}
